import { Box, Stack, SxProps } from '@mui/material';
import { PoiNavigation } from './PoiNavigation';
import { SelectedPoiMenuButton } from './SelectedPoiMenuButton';
import { PointOfInterest } from '@/__generated__/graphql';

const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  p: 1,
  py: 2,
  cursor: 'pointer',
  justifyContent: 'space-between',
};

type Props = {
  selectedPoiInfo: PointOfInterest;
  enableNavigation?: boolean;
  styleSx?: SxProps;
  onDelete: () => void;
};

export const PoiHeader = ({ selectedPoiInfo, enableNavigation, styleSx, onDelete }: Props) => (
  <Box sx={{ ...headerStyles, flexShrink: 0 }}>
    <Stack direction="row" alignItems="center">
      <PoiNavigation
        styleSx={styleSx}
        selectedPoiInfo={selectedPoiInfo}
        enableNavigation={enableNavigation}
      />
    </Stack>
    <SelectedPoiMenuButton onDelete={onDelete} poiId={selectedPoiInfo.id} />
  </Box>
);
